import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { AmazingTimePickerService } from 'amazing-time-picker';


declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr:any;
@Component({
  selector: 'app-add-outlet',
  templateUrl: './add-outlet.component.html',
  styleUrls: ['./add-outlet.component.css']
})
export class AddOutletComponent implements OnInit {
  nao = new Nanobar();
  countryCode: any;
  numChk = false;
  description: any;
  phone: any;
  about: any;
  name: any;
  btype: any;
  email: any;
  dob: any;
  address: any;
  btnDisable = false;
  city: any;
  restErrorCode: any;
  zip: any;
  street: any;
  state: any;
  area: any;
  latitude: any;
  longitude: any;
  apart: any;
  type: any;
  open_time: any;
  close_time: any;
  success: any;
  place: any;
  error_count: any;
  emailChk: any;
  managerName: any;
  managerEmail: any;
  dispensaryImage: any;
  dispensarySquareImage: any;
  usernameTaken: any;
  nameTakenError: any;
  clearTimeout: any;
  availableNameChkBtn: any;
   milli: any;
  seconds: any;
  minutes: any;
  hours: any;
  staticDate = '2018/05/16';
  dateObjOpen: any;
  utcOpen: any;
  afterUtcOpenTime: any;
  openFinalToSend: any;
  finalToSend: any;
  dateObjClose: any;
  utcClose: any;
  afterUtcCloseTime: any;
  closeFinalToSend: any;
  finalToSendClose: any;
  cityListSuccess: any;
  availableCities: any;
  is_city: any;
  cityLimitName: any;
  stateLimitName: any;
  user = {
    timezone: '',
  };
  timeZoneText: any;
  timeZoneTextFinal = '';
  timeZoneTextFinalToSend = '';
  addedTimeZone = '';
  bcatData: any;
  dispensarySquareTile: any;
  // clearTimeout: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;

  serviceAreaName = '';
  serviceArea: any;
  serviceAreaId = '-2';
  constructor(private dataService: DataService, private cs: CountryService,
              private router: Router, private chRef: ChangeDetectorRef, private atp: AmazingTimePickerService) {
    this.dataService.pageName = 'add outlet';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }
  changeTimezone(timezone) {
      this.user.timezone = timezone;
      // console.log('this.user.timezone', this.user.timezone);
      setTimeout(() => {
      this.timeZoneText = document.getElementById('timZoneSlectPicker').innerText;
      // console.log('a', this.timeZoneText);
      }, 1000);
  }
  timeSelect() {
    $('#timeZonePop').modal('show');
  }
  timeSelectConfirm() {
    this.timeZoneTextFinal = document.getElementById('timZoneSlectPicker').innerText;
    $('#timeZonePop').modal('hide');
  }
  getbusinessCategoryFunction() {
    // this.nao.go(30);
    this.dataService.getBusinessCategory(window.localStorage.getItem('token')).subscribe(
      (data) => {
        // this.nao.go(100);
        this.bcatData = data;
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  fineDispensaryName() {
    this.name = this.name.replace(/\b\w/g, function (l) { return l.toUpperCase()});
  }
  //  fineDispensaryName() {
  //   this.name = this.name.replace(/\b\w/g, function(l){ return l.toUpperCase()});
  //   clearTimeout(this.clearTimeout);
  //   this.clearTimeout = setTimeout(() => {
  //   this.nao.go(30);
  //   this.dataService.availableDispensaryName(window.localStorage.getItem('token'), this.name).subscribe(
  //     (data) => {
  //       this.nao.go(100);
  //       this.usernameTaken = data;
  //       this.nameTakenError = data;
  //       this.usernameTaken = this.usernameTaken.success;
  //       if (this.usernameTaken === false) {
  //         this.nameTakenError = this.nameTakenError.message;
  //         this.btnDisable = true;
  //       } else {
  //         this.nameTakenError = '';
  //         this.btnDisable = false;
  //       }
  //     },
  //     (error) => {
  //       this.nao.go(100);
  //       console.log('error', error);
  //     }
  //   );
  //     }, 1000);
  // }
//    tConvert(time) {
//   // Check correct time format and split into components
//      if (time === undefined) {return;}
//   time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
//
//   if (time.length > 1) { // If time format correct
//     time = time.slice (1);  // Remove full string match value
//     time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
//     time[0] = +time[0] % 12 || 12; // Adjust hours
//   }
//   return time.join (''); // return adjusted time or original string
// }
   convertMS(duration) {
    // console.log('duration', duration);
         this.milli = (duration % 1000) / 100,
         this.seconds = (duration / 1000) % 60,
         this.minutes = (duration / (1000 * 60)) % 60,
         this.hours = (duration / (1000 * 60 * 60)) % 24;
       this.hours = (this.hours < 10) ? '0' + this.hours : this.hours;
        this.minutes = (this.minutes < 10) ? '0' + this.minutes : this.minutes;
        this.seconds = (this.seconds < 10) ? '0' + this.seconds : this.seconds;
       return Math.floor(this.hours) + ':' + this.minutes + ':' + this.seconds;
    }
  addDispansaryFunction() {
    // this.error_count = 0;
    //  $('.c-label label').css('color', '#3d3e3d');
    //  $('.uploadText').css('color', '#3d3e3d');
    //  $('.uploadTextSquare').css('color', '#3d3e3d');
    //  $('.uploadTextTile').css('color', '#3d3e3d');
    //  $('.c-label input').css('border-color', '#ccc');
    //  $('.c-label select').css('border-color', '#ccc');
    //  $('.c-label textarea').css('border-color', '#ccc');
    //
    // this.btype =  $('#bCategory').val();
    // console.log('this.btype', this.btype);
    // this.city = $('#city').val();
    // this.zip = $('#zip').val();
    // this.state = $('#state').val();
    // this.area = $('#area').val();
    // this.apart = $('#apart').val();
    // this.dob = $('#datepicker').val();
    // this.address = $('#c-address input').val();
    // this.open_time = $('#timepicker1').val();
    // this.close_time = $('#timepicker2').val();
    // console.log('this.open_time', this.open_time);
    // console.log('this.close_time', this.close_time);
    // console.log('test image', this.dispensaryImage);
    // if (this.dispensaryImage === undefined) {
    //             $('.uploadText').css('color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.dispensarySquareImage === undefined) {
    //             $('.uploadTextSquare').css('color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.dispensarySquareTile === undefined) {
    //             $('.uploadTextTile').css('color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.name === '' || this.name === undefined) {
    //             $('#c-name label').css('color', '#a10a0d');
    //             $('#c-name input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.btype === '' || this.btype === null || this.btype === 'Select Product type') {
    //   $('#c-btype label').css('color', '#a10a0d');
    //   $('#c-btype select').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.about === '' || this.about === undefined) {
    //   $('#c-about label').css('color', '#a10a0d');
    //   $('#c-about textarea').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.managerName === '' || this.managerName === undefined) {
    //             $('#m-name label').css('color', '#a10a0d');
    //             $('#m-name input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.phone === '' || this.phone === undefined || this.numChk === true) {
    //             $('#c-phone label').css('color', '#a10a0d');
    //             $('#c-phone input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    //   this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (!this.emailChk.test(this.email) && this.email !== '') {
    //             $('#c-email label').css('color', '#a10a0d');
    //             $('#c-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (!this.emailChk.test(this.managerEmail) && this.managerEmail !== '') {
    //             $('#m-email label').css('color', '#a10a0d');
    //             $('#m-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.address === '' || this.address === undefined) {
    //             $('#c-address label').css('color', '#a10a0d');
    //             $('#c-address input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.city === '' || this.city === undefined) {
    //             $('#c-city label').css('color', '#a10a0d');
    //             $('#c-city input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.zip === '' || this.zip === undefined) {
    //             $('#c-zip label').css('color', '#a10a0d');
    //             $('#c-zip input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.state === '' || this.state === undefined) {
    //             $('#c-state label').css('color', '#a10a0d');
    //             $('#c-state input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //             $('#c-area label').css('color', '#a10a0d');
    //             $('#c-area input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.open_time === '' || this.open_time === undefined) {
    //             $('#c-openTime label').css('color', '#a10a0d');
    //             $('#c-openTime input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.close_time === '' || this.close_time === undefined) {
    //             $('#c-closeTime label').css('color', '#a10a0d');
    //             $('#c-closeTime input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.error_count > 0) {
    //   return;
    // }
    // if (this.latitude === undefined || this.longitude === undefined ) {
    //     toastr.error('Please Update the address & select it from Google suggestions for accuracy');
    //     return;
    //   }
    // if (this.cityListSuccess === false) {
    //   $('#availableCityPop').modal('show');
    //   return;
    //   }
    //   if (this.timeZoneTextFinal === '') {
    //     toastr.error('Please select a time zone');
    //     return;
    //   }
    //    // Time Zone Start
    // this.timeZoneTextFinalToSend = this.timeZoneTextFinal.split('GMT')[1];
    // this.timeZoneTextFinalToSend = this.timeZoneTextFinalToSend.split(')')[0];
    // console.log('this.timeZoneTextFinal', this.timeZoneTextFinalToSend);
    // this.addedTimeZone = this.timeZoneTextFinalToSend;
    // console.log('this.addedTimeZone', this.addedTimeZone);
    // // Time Zone End
    // if (this.addedTimeZone === '') {
    //   toastr.error('Please select a time zone');
    //   return;
    //   }
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    //   this.phone = '+' + getCode + this.phone;
    //   console.log('number', this.phone);
    // this.dateObjOpen = new Date(this.staticDate + ' ' + this.open_time + ' GMT' + this.addedTimeZone);
    // console.log('dateObjOpen', this.dateObjOpen);
    // this.utcOpen = this.dateObjOpen.toUTCString();
    // console.log('this.utcOpen', this.utcOpen);
    // this.afterUtcOpenTime = new Date(this.utcOpen);
    // console.log('this.afterUtcOpenTime', this.afterUtcOpenTime);
    // this.openFinalToSend = this.afterUtcOpenTime.getTime();
    // console.log('this.openFinalToSend', this.openFinalToSend);
    // this.finalToSend = this.convertMS(this.openFinalToSend);
    // console.log('time', this.finalToSend);
    // this.dateObjClose = new Date(this.staticDate + ' ' + this.close_time + ' GMT' + this.addedTimeZone);
    // this.utcClose = this.dateObjClose.toUTCString();
    // this.afterUtcCloseTime = new Date(this.utcClose);
    // this.closeFinalToSend = this.afterUtcCloseTime.getTime();
    // this.finalToSendClose = this.convertMS(this.closeFinalToSend);
    // console.log('time', this.finalToSendClose);
    // console.log('this.finalToSend', this.finalToSend);
    // console.log('this.finalToSendClose', this.finalToSendClose);

     this.error_count = 0;
     $('.c-label label').css('color', '#3d3e3d');
     $('.uploadText').css('color', '#3d3e3d');
     $('.uploadTextSquare').css('color', '#3d3e3d');
     // $('.uploadTextTile').css('color', '#3d3e3d');
     $('.c-label input').css('border-color', '#ccc');
     $('.c-label select').css('border-color', '#ccc');
    // this.city = $('#city').val();
    // this.zip = $('#zip').val();
    // this.state = $('#state').val();
    // this.area = $('#area').val();
    // this.apart = $('#apart').val();
    // this.dob = $('#datepicker').val();
    // this.address = $('#c-address input').val();
    // this.open_time = $('#timepicker1').val();
    // this.close_time = $('#timepicker2').val();
    this.btype =  $('#bCategory').val();
    // if (this.dispensaryImage === undefined) {
    //             $('.uploadText').css('color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.dispensarySquareImage === undefined) {
    //             $('.uploadTextSquare').css('color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.dispensarySquareTile === undefined) {
    //             $('.uploadTextTile').css('color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.name === '' || this.name === undefined) {
                $('#c-name label').css('color', '#a10a0d');
                $('#c-name input').css('border-color', '#a10a0d');
                this.error_count ++;
    }
    if (this.btype === '' || this.btype === null || this.btype === 'Select Product type') {
      $('#c-btype label').css('color', '#a10a0d');
      $('#c-btype select').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    // if (this.about === '' || this.about === undefined) {
    //       $('#c-about label').css('color', '#a10a0d');
    //       $('#c-about textarea').css('border-color', '#a10a0d');
    //       this.error_count ++;
    // }
    if (this.managerName === '' || this.managerName === undefined) {
                $('#m-name label').css('color', '#a10a0d');
                $('#m-name input').css('border-color', '#a10a0d');
                this.error_count ++;
    }

    // if ( this.serviceAreaId === '-2' ) {
    //   $('#SelectService label').css('color', '#a10a0d');
    //   $('#SelectService select').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.serviceAreaId === '-1' && this.serviceAreaName === '') {
    //   $('#serviceName label').css('color', '#a10a0d');
    //   $('#serviceName input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }


    // if (this.phone === '' || this.phone === undefined || this.numChk === true) {
    //             $('#c-phone label').css('color', '#a10a0d');
    //             $('#c-phone input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
      this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // if (!this.emailChk.test(this.email) && this.email !== '') {
    //             $('#c-email label').css('color', '#a10a0d');
    //             $('#c-email input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (!this.emailChk.test(this.managerEmail) && this.managerEmail !== '') {
                $('#m-email label').css('color', '#a10a0d');
                $('#m-email input').css('border-color', '#a10a0d');
                this.error_count ++;
    }
    // if (this.address === '' || this.address === undefined) {
    //             $('#c-address label').css('color', '#a10a0d');
    //             $('#c-address input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.city === '' || this.city === undefined) {
    //             $('#c-city label').css('color', '#a10a0d');
    //             $('#c-city input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.zip === '' || this.zip === undefined) {
    //             $('#c-zip label').css('color', '#a10a0d');
    //             $('#c-zip input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.state === '' || this.state === undefined) {
    //             $('#c-state label').css('color', '#a10a0d');
    //             $('#c-state input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //             $('#c-area label').css('color', '#a10a0d');
    //             $('#c-area input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.open_time === '' || this.open_time === undefined) {
    //             $('#c-openTime label').css('color', '#a10a0d');
    //             $('#c-openTime input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    // if (this.close_time === '' || this.close_time === undefined) {
    //             $('#c-closeTime label').css('color', '#a10a0d');
    //             $('#c-closeTime input').css('border-color', '#a10a0d');
    //             this.error_count ++;
    // }
    if (this.error_count > 0) {
      return;
    }
    // if (this.latitude === undefined || this.longitude === undefined ) {
    //     toastr.error('Please Update the address & select it from Google suggestions for accuracy');
    //     return;
    //   }
    // if (this.cityListSuccess === false) {
    //   $('#availableCityPop').modal('show');
    //   return;
    //   }
    //   if (this.timeZoneTextFinal === '') {
    //     toastr.error('Please select a time zone');
    //     return;
    //   }
       // Time Zone Start
    // this.timeZoneTextFinalToSend = this.timeZoneTextFinal.split('GMT')[1];
    // this.timeZoneTextFinalToSend = this.timeZoneTextFinalToSend.split(')')[0];
    // console.log('this.timeZoneTextFinal', this.timeZoneTextFinalToSend);
    // this.addedTimeZone = this.timeZoneTextFinalToSend;
    // console.log('this.addedTimeZone', this.addedTimeZone);
    // // Time Zone End
    // if (this.addedTimeZone === '') {
    //   toastr.error('Please select a time zone');
    //   return;
    //   }
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    //   this.phone = '+' + getCode + this.phone;
    //   console.log('number', this.phone);
    // this.dateObjOpen = new Date(this.staticDate + ' ' + this.open_time + ' GMT' + this.addedTimeZone);
    // console.log('dateObjOpen', this.dateObjOpen);
    // this.utcOpen = this.dateObjOpen.toUTCString();
    // console.log('this.utcOpen', this.utcOpen);
    // this.afterUtcOpenTime = new Date(this.utcOpen);
    // console.log('this.afterUtcOpenTime', this.afterUtcOpenTime);
    // this.openFinalToSend = this.afterUtcOpenTime.getTime();
    // console.log('this.openFinalToSend', this.openFinalToSend);
    // this.finalToSend = this.convertMS(this.openFinalToSend);
    // console.log('time', this.finalToSend);
    // this.dateObjClose = new Date(this.staticDate + ' ' + this.close_time + ' GMT' + this.addedTimeZone);
    // this.utcClose = this.dateObjClose.toUTCString();
    // this.afterUtcCloseTime = new Date(this.utcClose);
    // this.closeFinalToSend = this.afterUtcCloseTime.getTime();
    // this.finalToSendClose = this.convertMS(this.closeFinalToSend);
    // console.log('time', this.finalToSendClose);
    // console.log('this.finalToSend', this.finalToSend);
    // console.log('this.finalToSendClose', this.finalToSendClose);


    this.nao.go(30);
    this.btnDisable = true;
    this.dataService.addDispansary(window.localStorage.getItem('token'),
      this.name, this.btype, this.about, this.phone,
      this.email, this.dispensaryImage, this.address, this.street, this.city, this.zip,
      this.state, this.area, this.apart, this.finalToSend, this.finalToSendClose, this.managerName, this.managerEmail,
      this.dispensarySquareImage, this.dispensarySquareTile, this.latitude, this.longitude, this.addedTimeZone).subscribe(
      (data) => {
        console.log('outlet data');
        this.nao.go(100);
        this.success = data;
        this.is_city = data;
        this.is_city = this.is_city.is_city;
        this.restErrorCode = data;
        this.restErrorCode = this.restErrorCode.rest_error_code;
        this.success = this.success.success;
        if (this.restErrorCode === 1) {
          toastr.error('Some thing went wrong');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 2) {
          toastr.error('Please login again');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 3) {
          toastr.error('Customer already exists');
          this.btnDisable = false;
        }
        if (this.restErrorCode === 4) {
          toastr.error('Customer does not exist');
          this.btnDisable = false;
        }
        if (this.success === true) {
          this.btnDisable = false;
          this.router.navigate(['dispensaries']);
           toastr.success('Dispensary added successfully');
        }
        if (this.success === false) {
          this.btnDisable = false;
        }
        // if (this.is_city === false) {
        //     $('#availableCityPop').modal('show');
        //     this.btnDisable = false;
        //   }
      },
      (error) => {
        this.nao.go(100);
        this.btnDisable = false;
        console.log('error', error);
      }
    );
  }
 // inputAddress() {
 //    var context = this;
 //    const input = document.getElementById('searchTextField');
 //
 //    const searchBox = new google.maps.places.Autocomplete(input);
 //    searchBox.addListener('place_changed', function() {
 //
 //      console.log('place changed');
 //      context.place = searchBox.getPlace();
 //      console.log('address', context.place);
 //      context.addressDetail();
 //    });
 //  }
  addressDetail() {
    this.street = '';
    var cityVal = '';
    var cityZip = '';
    console.log('chk address detail', this.place);
       for(var i = 0; i < this.placeDetailData.length; i++) {
      for(var j = 0; j < this.placeDetailData[i].types.length; j++) {
        // if (this.placeDetailData[i].types[j] === 'administrative_area_level_2') {
        //   // this.city = this.placeDetailData[i].long_name;
        //   // console.log('city', this.city);
        //    $('#city').val(this.placeDetailData[i].long_name);
        //    cityVal = this.placeDetailData[i].long_name;
        // }
        if (this.placeDetailData[i].types[j] === 'locality') {
          this.city = this.placeDetailData[i].long_name;
          console.log('city', this.city);
           $('#city').val(this.placeDetailData[i].long_name);
           cityVal = this.placeDetailData[i].long_name;
        }
         if (this.placeDetailData[i].types[j] === 'street_number') {
          this.street = this.placeDetailData[i].long_name;
          console.log('street number', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'route') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('route', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_2') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 2', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_1') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 1', this.street);
        }

        if (this.placeDetailData[i].types[j] === 'administrative_area_level_1') {
          // this.state = this.placeDetailData[i].long_name;
          $('#state').val(this.placeDetailData[i].short_name);
          this.stateLimitName = this.placeDetailData[i].short_name;
        }

        if (this.placeDetailData[i].types[j] === 'country') {
          // this.area = this.placeDetailData[i].long_name;
          $('#area').val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === 'postal_code') {
          // this.zip = this.placeDetailData[i].long_name;
          console.log('postal; code', this.placeDetailData[i].long_name);
          $('#zip').val(this.placeDetailData[i].long_name);
          cityZip = this.placeDetailData[i].long_name;
        } else {
            $('#zip').val('');
        }

        }
      }
      console.log('cityVal', cityVal);
          console.log('cityZip', cityZip);
          if (cityVal !== '' && cityZip !== '') {
          this.availableCityList(cityVal, cityZip);
          }
    }
    restrictUserInput($event) {
    $event.preventDefault();
  }
   countryValidation() {
    var code = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    code = '+' + code;
    var val = $('#phoneValue').val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          console.log('valid');
          this.numChk = false;
          $('#phoneValue').css('border-color', '#ccc');
        } else {
          console.log('invalid');
          this.numChk = true;
          $('#phoneValue').css('border-color', '#eb3b3b');
        }
      }
    }
  }
  prevent($event) {
   console.log('prevent default', $event.keyCode);
   if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
   if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
 }
 availableCityList(city, zip) {
    this.cityLimitName = city;
    this.nao.go(30);
    this.dataService.availableCityList(window.localStorage.getItem('token'), city, zip).subscribe(
      (data) => {
        this.nao.go(100);
        this.cityListSuccess = data;
         if (this.cityListSuccess.rest_error_code === 1) toastr.error('Some thing went wrong');
        if (this.cityListSuccess.rest_error_code === 2) toastr.error('Please login again');
        if (this.cityListSuccess.rest_error_code === 4) toastr.error('Doest not exist');
        // this.cityListSuccess = this.cityListSuccess.message;
        this.cityListSuccess = this.cityListSuccess.success;
        if(this.cityListSuccess === false) {
          this.availableCities = data;
          this.availableCities = this.availableCities.city_list;
          setTimeout(() => { this.chRef.detectChanges(); }, 100);
          setTimeout(() => {
          console.log('availableCities', this.availableCities);
          $('#availableCityPop').modal('show');
          }, 2000);
        } else {
        }
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  chkCityAvailability() {
    var zip;
    var city;
    city = $('#city').val();
    zip = $('#zip').val();
    if (city !== '' && zip !== '') {
    this.availableCityList(city, zip);
    }
  }
  functionTogetPlace () {
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
     this.dataService.googleAddress(this.address).subscribe(
      (data) => {
        this.placeSuggestionsData = data;
        this.placeSuggestionsData = this.placeSuggestionsData.predictions;
        console.log('place google data', this.placeSuggestionsData);
        this.placeDataFound = true;
        if ($('.myDrop').hasClass('open')) {

        } else {
          $('.myDrop').addClass('open');
        }
        // this.addressLoad = false;
        // $('#searchTextField').click();
        // $('#searchTextField').focus();
      },
      (error) => {
      }
    );
     }, 1000);
  }
  functionTogetPlaceDetail (name, id) {
    this.addressLoad = true;
    this.address = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
     this.dataService.googleAddressDetail(id).subscribe(
      (data) => {
        console.log('place google detail data', data);
        this.placeDetailData = data;
        this.placeDetailData = this.placeDetailData.result;
        this.latitude = this.placeDetailData.geometry.location.lat;
        this.longitude = this.placeDetailData.geometry.location.lng;
        console.log('this.latitude', this.latitude);
        console.log('this.longitude', this.longitude);
        this.placeDetailData = this.placeDetailData.address_components;
        setTimeout(() => {
          this.addressDetail();
          this.addressLoad = false;
        }, 1000);
      },
      (error) => {
      }
    );
     }, 1000);
  }
  // bannerChangeFunction () {
  // $('#fileChk').change(function(){
  // console.log('in the file check: ',$('#Error').text())
  // if($('#Error').text()=='show'){
  //     $('#upload_image_Error').modal('show');
  //     $('#Error').text('');
  // }else{
  //   $('#cropperBannerImgPop').modal('show');
            // }
        // });
  // }
  clearBusinessImage() {
    $('.cropit-image-input').val('');
  }
  clearLogoImage() {
    $('.cropit-image-input2').val('');
  }
  clearTileImage() {
    $('.cropit-image-input-tile').val('');
  }
  expotyBanner() {
    $('.cropit-image-input').val('');
    this.dispensaryImage = $('.image-cropper').cropit('export', {
        originalSize: true,
        quality: 1,
        type: 'image/png',
    });
    // console.log('banner export', this.dispensaryImage);
    $('#cropperBannerImgPop').modal('hide');
  }
  expotyProfile() {
    $('.cropit-image-input2').val('');
    this.dispensarySquareImage = $('.image-cropper2').cropit('export', {
        originalSize: true,
        quality: 1,
        type: 'image/png',
    });
    // console.log('banner export', this.dispensarySquareImage);
    $('#cropperProfileImgPop').modal('hide');
  }
  expotyTile() {
    $('.cropit-image-input-tile').val('');
    this.dispensarySquareTile = $('.image-cropper-tile').cropit('export', {
        originalSize: true,
        quality: 1,
        type: 'image/png',
    });
    // console.log('banner export', this.dispensarySquareTile);
    $('#cropperTileImgPop').modal('hide');
  }

  getServiceAreaFunction() {
    // this.nao.go(30);
    this.dataService.getServiceArea(window.localStorage.getItem('token')).subscribe(
      (data) => {
        // this.nao.go(100);
        this.serviceArea = data;
        this.serviceArea = this.serviceArea.city_list;
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  chanheServiceArea(id) {
    this.serviceAreaName = '';
    this.serviceAreaId = id;
    if ( this.serviceAreaId === '-1' ) {
      setTimeout(() => {
        $('#serviceName input').focus();
      }, 700);
    }

  }

  ngOnInit() {
    this.getServiceAreaFunction();
    this.getbusinessCategoryFunction();
//     $('.clockpicker').clockpicker({
//     placement: 'top',
//     align: 'left',
//     donetext: 'Done'
// });
    // $('#image-cropper').cropit();
    // $('#image-cropper2').cropit();
    setTimeout(() => {
     $('.image-cropper').cropit({
        $preview: $('.cropit-preview'),
        $zoomSlider: $('.cropit-image-zoom-input-banner'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        originalSize: true,
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
        // freeMove: true
    });
     }, 1500);
     $('#cropit-image-input').change(function() {
       console.log('in image preview');
       if ($('.cropit-image-input').val() !== '') {
        $('#cropperBannerImgPop').modal('show');
        }
     });
     setTimeout(() => {
    $('.image-cropper2').cropit({
        $preview: $('.cropit-preview2'),
        $fileInput: $('.cropit-image-input2'),
        $zoomSlider: $('.cropit-image-zoom-input-logo'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        originalSize: true,
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
    });
    }, 1500);
    $('#cropit-image-input2').change(function() {
       console.log('in image preview2');
       console.log('', $('.cropit-image-input2').val());
       if ($('.cropit-image-input2').val() !== '') {
        $('#cropperProfileImgPop').modal('show');
        }
     });
    setTimeout(() => {
    $('.image-cropper-tile').cropit({
        $preview: $('.cropit-preview-tile'),
        $fileInput: $('.cropit-image-input-tile'),
        $zoomSlider: $('.cropit-image-zoom-input-tile'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        originalSize: true,
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
    });
    }, 1500);
    $('#cropit-image-input-tile').change(function() {
       console.log('in image preview2');
       console.log('', $('.cropit-image-input-tile').val());
       if ($('.cropit-image-input-tile').val() !== '') {
        $('#cropperTileImgPop').modal('show');
        }
     });
    $('.select-image-btn').click(function() {
      console.log('in image preview change button');
      $('#cropit-image-input').click();
    });
    $('.select-image-btn2').click(function() {
      $('#cropit-image-input2').click();
    });
    $('.select-image-btn-tile').click(function() {
      $('#cropit-image-input-tile').click();
    });
    var context = this;
    // $(function () {
    //   $('#dispansaryimg').change(function () {
    //
    //     console.log('image change', this.files[0]);
    //     if (this.files && this.files[0]) {
    //       var reader = new FileReader();
    //       // this.driving_license_front = this.files[0];
    //       // console.log('file 1 front cover chk', this.driving_license_front);
    //       reader.onload = (function(file) {
    //         context.dispensaryImage = file.target;
    //         context.dispensaryImage = context.dispensaryImage.result;
    //         console.log('base 64 1 image chk', context.dispensaryImage);
    //         return imageIsLoadedDispansary(file);
    //       });
    //       reader.readAsDataURL(this.files[0]);
    //     }
    //   });
    //   function imageIsLoadedDispansary(e) {
    //   $('#pImg1').attr('src', e.target.result);
    // }
    // });
      $('#phone').intlTelInput({
        // autoFormat: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss',
        autoPlaceholder: false,
        preferredCountries: ['GB'],
        preventInvalidNumbers: true,
        // stop the user from typing invalid dial codes
        preventInvalidDialCodes: true,
        formatOnDisplay: true,
        separateDialCode: false,
      });
      var countryCode;
       setTimeout(() => {
        countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        $('#phone').val('+' + countryCode);
       }, 1000);
        $('#phone').change(
                function () {
                     countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
                    $('#phone').val('+' + countryCode);

                }
            );
    // this.inputAddress();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#outlet').css('color', '#d77229');
  }
}



// WEBPACK FOOTER //
// ./src/app/add-outlet/add-outlet.component.ts